import React from 'react';
// Utils
import { useSetState } from 'utils';
// Admin Context
import { statusList } from 'context/AdminContext/constants';
// Elements
import Button from 'elements/Button';
import { SearchField } from 'elements/Forms';
import { CheckItem } from 'elements/ListItems';
// Components
import UserFilterDropdown from './UserFilterDropdown';
// Style
import styles from './style/userFilters.module.css';

interface UserFilterProps {
  handleClear: Function,
  handleSubmit: Function,
}

function UserFilters({ handleClear, handleSubmit }:UserFilterProps) {

  // State
  const defaultState = {
    organisations: [],
    role: '',
    status: 'All',
    filter: '',
  };
  const [state, setState] = useSetState(defaultState);
  const disabled = (state.roles === '' && state.filter === '' && state.organisations.length === 0);

  function clearUsers() {
    setState(defaultState);
    handleClear();
  }

  function handleRadioButtons(e:React.MouseEvent<HTMLInputElement>) {
    setState({ [e.currentTarget.name]: e.currentTarget.value });
  }

  function handleInput(e:React.ChangeEvent<HTMLInputElement>) {
    const { value } = e.target;
    if (value.length < 50) {
      setState({ filter: value });
    }
  }

  function handleKeydown(e:React.KeyboardEvent<HTMLInputElement>) {
    if (e.key === 'Enter' && state.filter.length > 0) {
      handleSubmit(state);
    }
  }
  
  return (
    <div className={styles.container}>
      <div>
        <SearchField
          keydownHandler={(e:React.KeyboardEvent<HTMLInputElement>) => handleKeydown(e)}
          onChangeHandler={(e:React.ChangeEvent<HTMLInputElement>) => handleInput(e)}
          onPasteHandler={(e:React.ChangeEvent<HTMLInputElement>) => handleInput(e)}
          placeholderText="First Name, Last Name or Employee ID"
          value={state.filter}
        />
      </div>
      <div className={styles.content}>
        <UserFilterDropdown
          label="Status"
          value={state.status}
        >
          {statusList.map(status => (
            <CheckItem
              borderInset={1}
              checked={state.status === status}
              handler={(e:React.MouseEvent<HTMLInputElement>) => handleRadioButtons(e)}
              key={status}
              label={status}
              name="status"
              value={status}
            />
          ))}
        </UserFilterDropdown>
      </div>
      <div className={styles.actions}>
        <Button
          btnStyle="light"
          disabled={disabled}
          handler={() => clearUsers()}
        >
          Clear
        </Button>
        <Button
          btnStyle="secondary"
          disabled={disabled}
          handler={() => handleSubmit(state)}
        >
          Update
        </Button>
      </div>
    </div>
  );
}

export default UserFilters;
